import styled, { css } from 'styled-components'

type ContainerProps = {
  $minWidth: number
  $hasActions: boolean
  $sortable?: boolean
}

export const Container = styled.div<ContainerProps>(
  ({ $minWidth, $hasActions }) => css`
    min-width: ${$minWidth}px;

    ${$hasActions &&
    css`
      margin-right: var(--space-n1200);
    `}
  `,
)

export const EmptyComponent = styled.div`
  margin-top: var(--space-2000);
  margin-bottom: var(--space-2000);
`

export const EmptyMessage = styled.div`
  margin-top: var(--space-800);
  margin-bottom: var(--space-800);

  text-align: center;
`
